<div class="container">
  <ion-img src="/assets/icon/{{ iconName }}"></ion-img>
  <span class="legend">{{ legend }}</span>
  <app-slip-component-status [status]="status"></app-slip-component-status>
</div>
